import React from "react";
import {steps} from '../../../assets/data/homeData'

const HowItWorksSection = () => (
  <section className="py-20 bg-gradient-to-b from-[#f5f6fa] to-[#e2bf9c]/10">
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-4xl font-extrabold text-center mb-16 text-[#0a363c]">
        How It Works
      </h2>

      {/* Steps timeline */}
      <div className="relative flex flex-col md:flex-row md:justify-between gap-12 md:gap-8">
        {/* Vertical line for mobile */}
        <div className="absolute left-6 md:hidden w-1 h-full bg-[#e2bf9c]/50" />

        {steps.map((step, idx) => (
          <div
            key={idx}
            className="relative flex flex-col items-start md:items-center md:flex-1"
          >
            {/* Step Circle */}
            <div className="flex items-center mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#0a363c] text-white font-bold shadow-lg">
                {idx + 1}
              </div>
              <span className="ml-4 md:hidden text-2xl">{step.icon}</span>
            </div>

            {/* Content */}
            <div className="pl-16 md:pl-0 text-left md:text-center">
              <h3 className="text-xl font-semibold text-[#0a363c] mb-2 flex items-center gap-2 justify-start md:justify-center">
                <span className="hidden md:inline text-2xl">{step.icon}</span>
                {step.title}
              </h3>
              <p className="text-[#0a363c]/80 text-base leading-relaxed max-w-xs">
                {step.description}
              </p>
            </div>

            {/* Connector line for desktop */}
            {idx !== steps.length - 1 && (
              <div className="hidden md:block absolute top-6 right-0 w-full h-1 bg-[#e2bf9c]/50 -z-10" />
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorksSection;

